<template>
  <d2-container>
    <div style="padding: 40px;">
      <el-descriptions title="任务信息">
        <el-descriptions-item label="ID">{{ info.id }}</el-descriptions-item>
        <el-descriptions-item label="名称">{{ info.name }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag v-if="info.status === 0" type="info">未开始</el-tag>
          <el-tag v-if="info.status === 1" type="warning">进行中</el-tag>
          <el-tag v-if="info.status === 2" type="success">已完成</el-tag>
          <el-tag v-if="info.status === 3" type="danger">失败</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="输入">
          <el-image :src="info.thumbnail" style="width: 100px; height: 100px;"></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="输出">
          <el-image v-if="info.outThumbnail" :src="info.outThumbnail" style="width: 100px; height: 100px;"></el-image>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="子任务">
        <el-descriptions-item>
          <el-table :data="info.subTasks">
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 0" type="info">未开始</el-tag>
              <el-tag v-if="scope.row.status === 1" type="warning">进行中</el-tag>
              <el-tag v-if="scope.row.status === 2" type="success">已完成</el-tag>
              <el-tag v-if="scope.row.status === 3" type="danger">失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="waitNum" label="排队数"></el-table-column>
          <el-table-column prop="inputImg" label="输入">
            <template slot-scope="scope">
              <!-- 图片列表 -->
              <el-image v-for="(img, index) in scope.row.inputImg" :preview-src-list="scope.row.inputImg" :key="index" :src="img"
                style="width: 100px; height: 100px;"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="outputImgList" label="输出">
            <template slot-scope="scope">
              <el-image v-for="(img, index) in scope.row.outputImgList" :preview-src-list="scope.row.outputImgList" :key="index" :src="img"
                style="width: 100px; height: 100px;"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="errorMsg" label="错误信息"></el-table-column>
        </el-table>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </d2-container>
</template>
<script>
import { getAigcTaskInfo, getAigcTaskStatus } from '@/api/merchant/service/project'
export default {
  name: 'aigcTask',
  data () {
    return {
      info: {},
      timer: null
    }
  },
  mounted () {
    this.getInfo()
    this.timer = setInterval(() => {
      this.updateStatus()
    }, 2000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getInfo () {
      let id = this.$route.query.id
      getAigcTaskInfo(id).then(res => {
        this.info = res
        this.info.subTasks.forEach(item => {
          if (item.inputImg.indexOf('[') === 0) {
            item.inputImg = JSON.parse(item.inputImg)
          } else {
            item.inputImg = [item.inputImg]
          }
        })
      })
    },
    updateStatus () {
      let id = this.$route.query.id
      if (!id) {
        return
      }
      getAigcTaskStatus(id).then(res => {
        // 更新状态
        this.info.status = res.status
        let subTasksStatus = res.subTaskStatus
        this.info.subTasks.forEach(item => {
          // 更新子任务状态 筛选对应id的子任务
          let subTask = subTasksStatus.find(sub => sub.id === item.id)
          if (subTask) {
            item.status = subTask.status
            item.waitNum = subTask.waitNum
            item.errorMsg = subTask.errorMsg
          }
        })
        if (res.status === 2) {
          // 更新输出图片
          this.getInfo()
        } else if (res.status === 3) {
          this.$message.error('任务失败')
        } else {
          setTimeout(() => {
            this.updateStatus()
          }, 2000)
        }
      })
    }
  }
}
</script>
